const WorkflowStages = {
  Draft: 1,
  PendingSignature: 2,
  BatchStaging: 3,
  PendingReview: 4,
  UnderInitialReview: 5,
  PendingSecondaryReview: 6,
  UnderSecondaryReview: 7,
  PendingExpertReview: 8,
  UnderExpertReview: 9,
  Complete: 100
};

export default WorkflowStages;
